<template>
  <div
    class="flex flex-grow-1 w-1/3 cursor-pointer hover:bg-gray-100 duration-300 transition p-2 rounded leading-none relative"
  >
    <span class="flex items-center">
      <span/>
      <span
        class="mr-2 h-6 w-6 border border-roc-blue rounded bg-white flex justify-center items-center"
        @click="toggleBuildingActive"
      >
        <i
          v-if="building.active"
          class="fas fa-check"
        />
      </span>
    </span>
    <span class="text-base py-1 leading-none font-medium items-center justify-center">
      {{ building.name }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    building: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  emits: ['activate'],
  setup(props, context) {
    return {
      toggleBuildingActive() {
        context.emit('activate', props.index);
      }
    };
  }
};
</script>
